import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { Country } from './country.dto';

@Injectable({
  providedIn: 'root',
})
export class CountryResource {
  private readonly httpClient = inject(HttpClient);

  fetchCountry(): Observable<Country> {
    return this.httpClient
      .get<Country>(`${window.location.origin}/country`, { observe: 'response' })
      .pipe(
        map(({ headers }) => headers.get('Country') as Country),
        catchError(() => of(Country.Others))
      );
  }
}
